<template>
    <footer>
        <div class="footerCopyright">
            <div class="left">
                <div class="policy">
                    <div class="title">약관및정책</div>
                    <ul>                    
                        <li><router-link to="/main/policy/service">이용약관</router-link></li>
                        <li><router-link to="/main/policy/privacy">개인정보취급방침</router-link></li>
                        <li><router-link to="/main/policy/refusal">이메일주소무단수집거부</router-link></li>
                        <li><router-link to="/main/policy/youth">청소년보호정책</router-link></li>

                        <li class="board" @click="linkboard('inquiry')">1:1문의</li>
                        <li class="board" @click="linkboard('alliance')">광고/제휴</li>
                        <li class="board" @click="linkboard('managerpolicy')">파트너정책</li>
                    </ul>
                </div>
                <div class="wrapper">                
                    <div class="copyText">
                        <p> 게임조아(GAMEJOA)의 모든 컨텐츠 저작권은 [티지엠(주)]에 있으며, 무단도용시 법적 불이익을 받습니다.<br>
                        티지엠(주), 경기도 광명시 일직로 43. GIDC 씨동 1810호, 대표 박병규<br>
                        긴급한 문의 ggjoa@gamejoa.com 전화번호 070-4010-5157 <br>
                        Copyright @{{ siteName }} All Rights Reserved.</p>
                    </div>               
                </div>
            </div>
            
            <div class="right">
                <div class="grac_link" >
                     <img src="@/assets/imgs/grac_link.png" @click="grac_link()">
                </div>
            </div>
        </div>           
    </footer>
    <div class="mode" v-if="isMobile">
        <div>
            <span class="mobileview" @click="modechange()">모바일 버전</span>
        </div>
    </div> 
</template>
<script>
import { updateMenu } from '@/utils/menu.js';
export default {
    data(){
        return{
            isMobile:false
        }
    },
    computed:{
        siteName(){
            return this.$store.state.siteName;
        },        
    },
    mounted(){
        this.deviceCheck();
    },
    methods:{
        grac_link()
        {
            updateMenu('Gamegrade','gracsearch', this.$store);
            
            this.$router.push({
                path: "/main/community/gracsearch"
            });
        },
        linkboard(board)
        {            
            this.$store.commit("menu/setActiveMenu", 'home');
            if(board === 'managerpolicy')
            {
                this.$router.push({
                    name: "managerpolicy"
                });
            }else{
                this.$router.push({
                    path: "/main/community/"+board+"/write"
                });
            }
          
        },
        modechange(){
            this.$router.push({name:'m_Home'});
            this.$store.state.sets.mode = 'MOBILE';
        },
        deviceCheck(){
            if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) { 
                // 모바일인 경우 
                this.isMobile = true
            }                
           
        }

    }
    
}
</script>
<style lang="scss" scoped>
.mode{
    display: flex;
    justify-content: center;
    padding:20px 0;
    .mobileview{
        display: inline-block;
        padding:5px 40px;
        background: rgb(37, 77, 255);
        border-radius: 999px;
        font-size:16px;
        color:#fff;
        cursor: pointer;
    }
}
footer{
    width: 100%;
    background: #fff;
    border-bottom: 1px solid #eee;
    border-top: 1px solid #dee3eb;
    margin-top:20px;
    color: rgb(116, 116, 116);
    font-family:  malgungothic, Gulim, dotum, 돋음, sans-serif;
    display: flex;
    justify-content: center;    
    .footerCopyright{
        display: flex;
        width: 1300px;
        .left{
            width:900px;
            .policy{
                width: 100%;    
                margin:0 auto;
                margin-top:20px;
                .title{
                    font-weight:bold;
                }
                ul{
                    margin-top:10px;
                    display:flex;
                    li{
                        padding-right:20px;
                    }
                }
                .board{
                    font-weight: bold;
                    cursor: pointer;
                    color: #000;
                }
            }
            .wrapper {
                width: 100%;
                margin: 0 auto;
                    .copyText {                
                        font-size: 12px;
                        line-height: 21px;                
                        margin: 30px 0;
                    }
            }
        }
        .right{
            padding:20px 0 0 20px;
            width: 400px;
            .grac_link{                
                text-align: right;
                img{
                    cursor:pointer;
                }
            }
        }
        
    }
    
}
</style>